import { defineComponent as b, computed as _, openBlock as t, createElementBlock as a, Fragment as o, renderList as p, normalizeClass as r, createElementVNode as c, createBlock as v, toDisplayString as u, createCommentVNode as d } from "vue";
import k from "./index60.js";
const h = ["aria-label"], y = ["aria-label"], x = { class: "relative flex shrink-0 flex-col items-center justify-start gap-2" }, C = {
  key: 1,
  class: "text-default-muted-dark text-base font-normal"
}, S = /* @__PURE__ */ b({
  __name: "BaseStepper",
  props: {
    current: { default: 0 },
    size: { default: "md" },
    variant: {},
    dotConfig: {},
    labelConfig: {}
  },
  setup(m) {
    const e = m, g = _(() => e.variant === "label" ? e.labelConfig.stepLabelList.map((i, s) => s) : Array.from({ length: e.dotConfig.count }, (i, s) => s)), f = (i) => `pagination-join-indicator ${i === e.current ? "pagination-join-line pagination-join-line-active" : "pagination-join-dot pagination-join-dot-inactive"}`;
    return (i, s) => e.variant === "dot" ? (t(), a("div", {
      key: 0,
      class: "pagination-join",
      "data-name": "Stepper/stepper",
      "aria-label": `Step ${e.current + 1}`
    }, [
      (t(!0), a(o, null, p(g.value, (l) => (t(), a("div", {
        key: l,
        class: r(f(l))
      }, null, 2))), 128))
    ], 8, h)) : e.variant === "label" ? (t(), a("div", {
      key: 1,
      class: r(["relative flex items-center justify-center", e.size === "sm" ? "gap-3" : "gap-6"]),
      "data-name": "Stepper/stepper",
      "aria-label": `Step ${e.current + 1}`
    }, [
      (t(!0), a(o, null, p(e.labelConfig.stepLabelList, (l, n) => (t(), a(o, { key: n }, [
        c("div", x, [
          c("div", {
            class: r(["flex size-10 shrink-0 items-center justify-center rounded-full p-2", n <= e.current ? "bg-bg-primary" : "bg-bg-bg-surface"])
          }, [
            n <= e.current ? (t(), v(k, {
              key: 0,
              name: "check-circle"
            })) : (t(), a("span", C, u(n + 1), 1))
          ], 2),
          c("div", {
            class: r([
              "whitespace-nowrap text-center text-[14px] font-medium leading-[18px] tracking-[-0.35px]",
              n <= e.current ? "text-[var(--chips-status-pending-text)]" : "text-default-muted"
            ])
          }, u(l), 3)
        ]),
        n < e.labelConfig.stepLabelList.length - 1 ? (t(), a("div", {
          key: 0,
          class: r(["bg-bg-bg-outline h-0.5 shrink-0", e.size === "sm" ? "w-10" : "w-20"])
        }, null, 2)) : d("", !0)
      ], 64))), 128))
    ], 10, y)) : d("", !0);
  }
});
export {
  S as default
};
